<template>
  <div>
    <!-- <nav-menu></nav-menu> -->
    <router-view />
  </div>
</template>

<script>
// import NavMenu from "./common/NavMenu";
// import ScrollTop from './common/ScrollTop';
export default {
  name: "Home",
  // components: { ScrollTop },

};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Home.vue